export default __webpack_public_path__ + "static/media/github-2-yellow.2656300b.svg";